import { render, staticRenderFns } from "./EditMyUserData.vue?vue&type=template&id=904e7eea&scoped=true&"
import script from "./EditMyUserData.vue?vue&type=script&lang=js&"
export * from "./EditMyUserData.vue?vue&type=script&lang=js&"
import style0 from "./EditMyUserData.vue?vue&type=style&index=0&id=904e7eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904e7eea",
  null
  
)

export default component.exports